module.exports = __webpack_public_path__ + "img/pc7.8597e09d.png";